import { Observable, of } from 'rxjs';
import { DataStore } from './data-store';

/**
 * Defines a single value data store using memory as the backing store
 * Semantically this is now different than managing a local variable,
 * however it can be used anywhere a dataStore is accepted.
 * It also has usefulness for testing classes that use a DataStore
 */
export abstract class MemoryDataStore<TData> extends DataStore<TData, TData> {

    private data: TData;

    /**
     * Initializes a new instance of DataStore<T>
     */
    constructor() {
        super();
    }

    /**
     * Implementation to get the stored data
     */
    protected getData(): Observable<TData> {
        return of(this.data);
    }

    /**
     * Implementation to set the stored data
     */
    protected setData(data: TData): Observable<void> {
        this.data = data;
        return of(null);
    }

    /**
     * Implementation to clear the stored data
     */
    protected clearData(): Observable<void> {
        this.data = undefined;
        return of(null);
    }
}
